import React from 'react';
import { Table, Form, Input } from 'antd';
import _ from 'lodash';
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: false,
  };

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = e => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error && error[e.currentTarget.id]) {
        return;
      }
      this.toggleEdit();
      handleSave({ ...record, ...values });
    });
  };
  renderCell = form => {
    this.form = form;
    const { children, dataIndex, record, title } = this.props;
    const { editing } = this.state;
    return editing ? (
      <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(dataIndex, {
          initialValue: record[dataIndex],
        })(<Input ref={node => (this.input = node)} onPressEnter={this.save} onBlur={this.save} />)}
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24, minHeight: 22, cursor: "pointer" }}
        onDoubleClick={this.toggleEdit}
      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      children,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}

class editable extends React.Component {
  constructor(props) {
    super(props);
  }
  handleSave = row => {//row为选中的某一行
    const { detailUrlstore, dataSource } = this.props;
    const newData = [...this.props.dataSource];
    const index = newData.findIndex(item =>
      row.id === item.id   //判断选中行的index
    );
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });//将当前行的数据替换为修改之后的数据
    this.props.handleClickdata({
      dataSource: {
        ...item,
        ...row,
      },
      newData: newData
    })//将修改之后的数据传回父组件做操作
  };

  renderTable = () => {
    const { dataSource, showTitle } = this.props;
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    let columns = this.props.columns.map(col => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    })

    return (
      <Table
        dataSource={dataSource}
        columns={columns}
        components={components}
        size="small"
        rowKey="_id"
        bordered
        pagination={false}
        showHeader={showTitle ? false : true}
        scroll={{ y: '300px' }}
      />
    );
  };

  render() {
    return (
      <div className="summary-card">
        {this.renderTable()}
      </div>
    );
  }
}

export default editable;